export default {
      id: "ic-euro-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-euro-usage",
      toString: function () {
        return this.url;
      }
    }